import * as z from "zod";

import { maintenancePlanCodeSchema } from "./maintenance-plan-code";
import { maintenancePlanGroupSchema } from "./maintenance-plan-group";

export const maintenancePlanGroupWithCodesSchema =
  maintenancePlanGroupSchema.extend({
    codes: z.array(maintenancePlanCodeSchema),
  });

export type MaintenancePlanGroupWithCodes = z.infer<
  typeof maintenancePlanGroupWithCodesSchema
>;
